import script from "./layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./layout.vue?vue&type=script&lang=ts&setup=true"

import "./layout.vue?vue&type=style&index=0&id=5f93e287&lang=less"

const __exports__ = script;

export default __exports__